export default __webpack_public_path__ + "static/media/kshss.f06835ee.JPG";